// extracted by mini-css-extract-plugin
export default {"container":"courseImage_container__jCRRh","image":"courseImage_image__tRHG4","mobile":"courseImage_mobile__mvoHi"};